import classnames from 'classnames';
import styles from './styles';
import { withStyles } from '@material-ui/core/styles';
import { useState } from 'react';
import Typography from '@material-ui/core/Typography';
import ArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import Collapse from '@material-ui/core/Collapse';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useCanEditWorklog } from 'common/hooks/use-can-edit-worklog';
import { format } from 'date-fns';
import WorklogDetailsCard from 'pages/ScheduleV6/components/card/WorklogDetailsCard';
import { getSheetEventTitle, getStatusColor, getStatusLetter } from 'pages/ScheduleV6/utils';
import { useHandleDrop } from 'pages/ScheduleV6/components/events/hooks/useHandleResourceDrop';
import { useFormattedHoursRange } from 'pages/ScheduleV6/components/hooks/useFormattedHoursRange';
import { SCHEDULE_VIEW_TYPES } from 'pages/ScheduleV6/constants/constants';


const WLAccordionItem = ({
  classes,
  sheet,
  userId = '', //?
  sheetsWithoutForemanIds,
  handleUpdate,
  locationColor,
}) => {
  const selectedDate = useSelector((state) => state.schedule.selectedDate);
  const { formattedHoursRange } = useFormattedHoursRange(sheet);
  const { handleDrop } = useHandleDrop({
    sheet: sheet,
  });

  const [expanded, setExpanded] = useState(false);

  const hasAccess = useCanEditWorklog(sheet);


  const handleExpandClick = () => {
    setExpanded(!expanded);
    handleUpdate();
  };

  const handleClose = () => {
    setExpanded(false);
    handleUpdate();
  }

  const navigate = useNavigate();


  const openWorklogDetails = () => {
    if (hasAccess) navigate(`/schedule/${format(selectedDate, 'yyyy-MM-dd')}?sheetId=${sheet._id}`);
  };


  const getStatusIconComponent = (sheet) => {
    const letter = getStatusLetter(sheet);
    const color = getStatusColor(sheet);
    return (
      <div
        className={classnames(
          locationColor ? classes.accordionItemLocationWrapper : classes.accordionItemImgWrapper
        )}
        style={{ borderColor: locationColor || color, color: color }}
      >
        {locationColor ? ' ' : letter}
      </div>
    );
  };

  return (
    <div
      onDragOver={(e) => e.preventDefault()}
      onDrop={handleDrop}
    >
      <div className={classnames(classes.itemWrapper)}>
        <div
          className={classnames(
            classes.itemInner,
            sheetsWithoutForemanIds.includes(sheet._id) && classes.missingCL
          )}
          onClick={openWorklogDetails}
        >
          {getStatusIconComponent(sheet)}
          <div className={classnames(classes.accordionItemTextWrapper)}>
            <Typography
              style={{ display: 'block', marginBottom: 5 }}
              className={classnames(Boolean(sheet.canceledAt) && classes.canceled)}
              variant="caption"
              color="textPrimary"
            >
              {getSheetEventTitle(sheet)}
            </Typography>
            <Typography variant="body1" color="textSecondary">
              {formattedHoursRange}
            </Typography>
          </div>
        </div>
        <ArrowRightIcon
          color="secondary"
          className={classnames(
            classes.previewCellArrow,
            expanded ? classes.openedArrow : classes.closedArrow
          )}
          fontSize={'small'}
          onClick={handleExpandClick}
        />
      </div>
      <Collapse in={expanded} timeout={0} unmountOnExit>
        <WorklogDetailsCard
          sheet={sheet}
          userId={userId}
          close={handleClose}
          view={SCHEDULE_VIEW_TYPES.monthly}
        />
      </Collapse>
    </div>
  );
};

export default withStyles(styles)(WLAccordionItem);
